import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OrderReturn } from 'src/app/models/order/order-return.model';
import { Reorder } from 'src/app/models/order/reorder.model';
import { Resident } from 'src/app/models/resident/resident.model';
import { ReportService } from 'src/app/services/api/report.service';
import { ResidentService } from 'src/app/services/api/resident.service';
import { AuthService } from 'src/app/services/web/auth.service';
import { ReportViewerService } from 'src/app/services/web/report-viewer.service';
import { ValidationService } from 'src/app/services/web/validation.service';

@Component({
  selector: 'app-leave-of-absence',
  templateUrl: 'leave-of-absence.component.html'
})
export class LeaveofAbsenceComponent implements OnInit, OnDestroy {
  public order: Reorder;
  public loaForm: FormGroup;
  public addedOrders: OrderReturn[] = [];
  public printMonographs = false;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private reportService: ReportService,
    private reportViewerService: ReportViewerService,
    private authService: AuthService,
    private residentService: ResidentService
  ) {}

  public ngOnInit(): void {
    this.loaForm = this.formBuilder.group({
      transferred: [0],
      returned: [0],
    });

    this.loaForm.get('returned').setValidators([
      ValidationService.controlGreaterThanOtherControl.bind(this, this.loaForm.get('returned'), this.loaForm.get('transferred')),
      Validators.required
    ]);

    this.loaForm.get('transferred').valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => this.loaForm.get('returned').updateValueAndValidity());

    this.authService.getCurrentFacility()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.reset();
        this.clear();
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public rxFound(order: Reorder): void {
    if(order === undefined){
      this.order = null;
      this.loaForm.reset();
    } else if (order !== undefined) {
      this.order = order;

      this.loaForm.get('transferred').setValidators([Validators.min(0.01), Validators.max(order.quantity)]);
    }
  }

  public add(): void {
    if (!this.loaForm.valid) {
      this.loaForm.markAllAsTouched();
      return;
    }

    this.addedOrders.push({
      ...this.order,
      quantityTransferred: this.loaForm.get('transferred').value,
      quantityReturned: this.loaForm.get('returned').value
    });

    this.reset();
  }

  public remove(order: OrderReturn): void {
    this.addedOrders.splice(this.addedOrders.findIndex(o => o === order), 1);
  }

  public reset(): void {
    this.loaForm.reset({transferred: 0, returned: 0});
    this.order = null;
  }

  public view(): void {
    this.reportViewerService.showReport(this.reportService.getLeaveOfAbsenceReport(this.authService.getCurrentFacilityValue(), this.printMonographs, this.addedOrders));
  }

  public clear(): void {
    this.addedOrders = [];
  }

  public navigateToResident(): void {
    this.residentService.emitResidentSelectionChange({ patientId: this.order.patientId, facilityId: this.authService.getCurrentFacilityValue() } as Resident);
  }
}
